module.exports = __webpack_public_path__ + "media/components/images/panels/6-a-3bc88de6c2522a867a46c614cd1d0b67.jpeg";